import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);

export interface DayOpen {
  start: string | null;
  end: string | null;
}
const MONDAY_FIRST_INDEX = [0, 1, 2, 3, 4, 5, 6];
const SUNDAY_FIRST_INDEX = [6, 0, 1, 2, 3, 4, 5];
export interface MarketOpenInterface {
  timeZone: string;
  openTime: DayOpen[];
  holidays: string[];
  earlyCloses?: { date: string; close: string }[]; // VD: { date: '24-12', close: '13:00' }
}
export const checkIsClosed = (groupName: string, dataOpen?: MarketOpenInterface) => {
  if (groupName === "crypto") {
    return false;
  }

  if (!dataOpen) {
    return false;
  }

  const now = dayjs().tz(dataOpen.timeZone);

  // định dạng ngày dạng "DD-MM"
  const parseDay = `${now.get("date").toString().padStart(2, "0")}-${(now.get("month") + 1)
    .toString()
    .padStart(2, "0")}`;

  // Check holiday (đóng hẳn)
  if (dataOpen.holidays.find((x) => x === parseDay)) {
    return true;
  }

  // Lấy index theo thứ trong tuần
  const todayIndex = now.startOf("week").toString().includes("Sun")
    ? SUNDAY_FIRST_INDEX[now.day()]
    : MONDAY_FIRST_INDEX[now.day()];

  // eslint-disable-next-line prefer-const
  let { start, end } = dataOpen.openTime[todayIndex];

  // Check early close
  const early = dataOpen.earlyCloses?.find((x) => x.date === parseDay);
  if (early) {
    end = early.close; // override giờ đóng
  }

  // Nếu nghỉ (null) thì đóng
  if (start === null && end === null) {
    return true;
  }

  const parseMinutes = now.get("hour") * 60 + now.get("minute");
  const timeStart = start === "" ? 0 : Number(start?.split(":")[0]) * 60 + Number(start?.split(":")[1]);
  const timeEnd = end === "" ? 24 * 60 : Number(end?.split(":")[0]) * 60 + Number(end?.split(":")[1]);

  if (timeStart < timeEnd && (parseMinutes < timeStart || parseMinutes > timeEnd)) {
    return true;
  }
  if (timeStart > timeEnd && parseMinutes > timeEnd && parseMinutes < timeStart) {
    return true;
  }

  return false;
};
